import { frontendURL } from '../../../helper/URLHelper';
import BookingsIndex from './pages/BookingsIndex.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: ['administrator', 'agent', 'contact_manage'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/bookings'),
    component: BookingsIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'bookings_dashboard_index',
        component: BookingsIndex,
        meta: commonMeta,
      },
    ],
  },
];
